// Handle app ui states here
import forOwn from 'lodash/forOwn';

import con, { mutationTypes } from '../mutationTypes';

// Register mutations for app state here before using them
mutationTypes.addModule('app', true);
mutationTypes.add('app', 'UPDATE_APP_STATE');

const app = {
  namespaced: true,
  state: {
    isFirebaseLoaded: false,
    isEditingProfile: false,
    isMenuOpen: false
  },
  mutations: {
    [con.UPDATE_APP_STATE](state, data) {
      forOwn(data, (v, k) => {
        state[k] = v;
      });
    }
  }
};

export default app;
